export const getUploadedFiles = (selectedValue) => {
  return Array.isArray(selectedValue)
    ? selectedValue
    : selectedValue
    ? [selectedValue]
    : [];
};

export const getFileLabel = (index, fileNameLabel, multiUpload) => {
  if (Array.isArray(fileNameLabel)) {
    return fileNameLabel[index] || `Document ${index + 1}`;
  }

  if (multiUpload && multiUpload[index]?.fileLabel) {
    return multiUpload[index].fileLabel;
  }

  return fileNameLabel || `Document ${index + 1}`;
};

export const shouldShowUploadButtons = (multiUpload, uploadedFiles) => {
  return multiUpload && uploadedFiles.length < multiUpload.length;
};

export const getRemainingUploadConfigs = (multiUpload, uploadedFiles) => {
  return multiUpload.slice(uploadedFiles.length);
};
